import axios from "axios";

const guardarPermisosServicios = async (id, permisos) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        }
    };

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/permisos/${id}`,
            {permisos},
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    guardarPermisosServicios
}

